import React from 'react';
import './DashboardCard.css';

function DashboardCard({ titulo, valor, icone, type }) {
  return (
    <div className="dashboard-card" data-type={type}>
      <div className="card-icon">
        <i className={`fas ${icone}`}></i>
      </div>
      <div className="card-content">
        <div className="card-title">{titulo}</div>
        <div className="card-value">{valor}</div>
      </div>
    </div>
  );
}

export default DashboardCard; 